import { render, staticRenderFns } from "./toggle_replies_widget.vue?vue&type=template&id=3b42215a"
import script from "./toggle_replies_widget.vue?vue&type=script&lang=js"
export * from "./toggle_replies_widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports